import { app } from '../../../app';

app.factory('Connector', Connector);

/** @ngInject */
function Connector($resource) {
    return $resource('app/rest/connectors/:id', {}, {
        'query' : {
            method : 'GET',
            isArray : true
        },
        'get' : {
            method : 'GET'
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/connectors/connectors.service.js